import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledCrmEnrichmentJobReviewContainer = styled(Flex)`
    gap: 36px;
    margin: 24px 0 0;
`;

export const StyledCrmEnrichmentJobReviewWrapper = styled.div`
    width: 100%;
`;

export const StyledCrmEnrichmentJobReviewValue = styled.div`
    display: flex;
    gap: 6px;
    ${setFontVariant("tab", colorsPalettes.carbon[500])};
    font-weight: 400;
    margin-bottom: 8px;
`;
